import { ApiProperty } from "@nestjs/swagger"
import { IsNotEmpty,  IsUUID } from "class-validator"

export class ChapterProgramConceptDto {
  @ApiProperty({ description: 'Identifiant unique du concept' })
  @IsNotEmpty()
  @IsUUID('4')  
  id!: string

  @ApiProperty({ description: 'Identifiant unique du chapitre' })  
  @IsNotEmpty()
  @IsUUID('4')
  chapterId!: string

  @ApiProperty({ description: 'Code du concept' })
  @IsNotEmpty()
  @IsUUID('4')
  programConceptId!: string
}
